import { Component } from '@theme/component';
import { QuantitySelectorUpdateEvent } from '@theme/events';

class QuantitySelectorComponent extends Component {
  increaseQuantity(event) {
    event.preventDefault();
    const input = this.refs.quantityInput;
    const max = parseInt(input.max) || 100;
    if (parseInt(input.value) < max) {
      input.stepUp();
      this.#onQuantityChange();
    }
  }

  decreaseQuantity(event) {
    event.preventDefault();
    const input = this.refs.quantityInput;
    const min = parseInt(input.min) || 1;
    if (parseInt(input.value) > min) {
      input.stepDown();
      this.#onQuantityChange();
    }
  }

  selectInputValue(event) {
    const input = this.refs.quantityInput;
    if (document.activeElement === input) input.select();
  }

  setQuantity(event) {
    event.preventDefault();
    const input = this.refs.quantityInput;
    let value = parseInt(input.value) || parseInt(input.min) || 1;
    const max = parseInt(input.max) || 100;
    const min = parseInt(input.min) || 1;

    if (value > max) value = max;
    if (value < min) value = min;

    input.value = value;
    this.#onQuantityChange();
  }

  #onQuantityChange() {
    const input = this.refs.quantityInput;
    const newValue = parseInt(input.value);
    input.dispatchEvent(
      new QuantitySelectorUpdateEvent(newValue, Number(input.dataset.cartLine))
    );
  }

  get quantityInput() {
    if (!this.refs.quantityInput) {
      throw new Error(
        'Missing <input ref="quantityInput" /> inside <quantity-selector-component />'
      );
    }
    return this.refs.quantityInput;
  }
}

if (!customElements.get('quantity-selector-component')) {
  customElements.define('quantity-selector-component', QuantitySelectorComponent);
}
